var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.ready ? _c('console-content', {
    attrs: {
      "max-width": "1024"
    }
  }, [_c('v-row', {
    staticClass: "mt-3 mt-md-8 px-1",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "tit tit--lg",
    attrs: {
      "cols": "auto"
    }
  }, [_vm.product._id ? _c('span', [_vm._v("상품상세")]) : _c('span', [_vm._v("상품등록")])]), _c('v-spacer')], 1), _c('v-card', {
    staticClass: "mx-1 mt-4"
  }, [_c('v-card-title', {
    staticClass: "pb-2"
  }, [_c('span', {
    staticClass: "tit tit--xs"
  }, [_c('b', [_vm._v("카테고리")])]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": ""
    },
    on: {
      "click": function click($event) {
        return _vm.product._categories.push(null);
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" 카테고리 추가")], 1)], 1), _c('v-card-text', _vm._l(_vm.product._categories, function (_category, index) {
    return _c('v-layout', {
      key: index,
      class: {
        'mt-4': index ? true : false
      },
      attrs: {
        "align-end": ""
      }
    }, [_c('category-select', {
      attrs: {
        "categories": _vm.categories,
        "allowDepth": [1, 2]
      },
      model: {
        value: _vm.product._categories[index],
        callback: function callback($$v) {
          _vm.$set(_vm.product._categories, index, $$v);
        },
        expression: "product._categories[index]"
      }
    }), 1 < _vm.product._categories.length ? _c('v-btn', {
      staticClass: "ml-2",
      attrs: {
        "small": "",
        "text": "",
        "icon": ""
      },
      on: {
        "click": function click($event) {
          return _vm.product._categories.splice(index, 1);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "size": "20"
      }
    }, [_vm._v("mdi-delete")])], 1) : _vm._e()], 1);
  }), 1)], 1), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "pr-md-1",
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('v-card', {
    staticClass: "mx-1"
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs font-weight-bold"
  }, [_vm._v("썸네일")]), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "no-gutters": "",
      "align-center": ""
    }
  }, [_vm.thumb ? _c('v-img', {
    attrs: {
      "src": _vm.thumb,
      "max-width": "96",
      "height": "auto",
      "contain": ""
    }
  }) : _c('v-sheet', {
    attrs: {
      "width": "96",
      "height": "96",
      "color": "d-flex justify-center align-center grey lighten-2"
    }
  }, [_c('v-icon', [_vm._v("mdi-image")])], 1), _c('v-file-input', {
    model: {
      value: _vm.product.thumb,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "thumb", $$v);
      },
      expression: "product.thumb"
    }
  })], 1)], 1)], 1), _c('v-card', {
    staticClass: "mx-1 mt-3"
  }, [_c('v-card-title', [_c('span', {
    staticClass: "tit tit--xs"
  }, [_c('b', [_vm._v("이미지")])]), _c('v-spacer'), _vm.product.images.length > 1 ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": ""
    },
    on: {
      "click": function click($event) {
        return _vm.product.images.pop();
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-minus")]), _vm._v("이미지삭제")], 1) : _vm._e(), _vm.product.images.length < 6 ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": ""
    },
    on: {
      "click": function click($event) {
        return _vm.product.images.push(null);
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v("이미지추가")], 1) : _vm._e()], 1), _c('v-card-text', [_c('v-draggable', {
    model: {
      value: _vm.product.images,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "images", $$v);
      },
      expression: "product.images"
    }
  }, _vm._l(_vm.product.images, function (image, index) {
    return _c('v-layout', {
      key: index,
      staticClass: "mb-4",
      attrs: {
        "no-gutters": "",
        "align-center": ""
      }
    }, [_vm.images[index] ? _c('v-img', {
      attrs: {
        "src": _vm.images[index],
        "max-width": "96",
        "height": "auto",
        "contain": ""
      }
    }) : _c('v-sheet', {
      attrs: {
        "width": "96",
        "height": "96",
        "color": "d-flex justify-center align-center grey lighten-2"
      }
    }, [_c('v-icon', [_vm._v("mdi-image")])], 1), _c('v-file-input', {
      model: {
        value: _vm.product.images[index],
        callback: function callback($$v) {
          _vm.$set(_vm.product.images, index, $$v);
        },
        expression: "product.images[index]"
      }
    })], 1);
  }), 1)], 1)], 1)], 1), _c('v-col', {
    staticClass: "pl-md-1",
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('v-card', {
    staticClass: "mx-1 mt-3 mt-md-0"
  }, [_c('v-card-title', [_c('span', {
    staticClass: "tit tit--xs"
  }, [_c('b', [_vm._v("기본정보")])])]), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "상품이름",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.product.name,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "name", $$v);
      },
      expression: "product.name"
    }
  }), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.product._id,
      expression: "product._id"
    }],
    staticClass: "mt-4",
    attrs: {
      "label": "상품코드",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.product.code,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "code", $$v);
      },
      expression: "product.code"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "진열순서",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.product.no,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "no", $$v);
      },
      expression: "product.no"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "작가",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.product.writer,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "writer", $$v);
      },
      expression: "product.writer"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "출판사",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.product.publisher,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "publisher", $$v);
      },
      expression: "product.publisher"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "소비자가",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.product.costPrice,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "costPrice", $$v);
      },
      expression: "product.costPrice"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "판매가",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.product.salePrice,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "salePrice", $$v);
      },
      expression: "product.salePrice"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "재고",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.product.stock,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "stock", $$v);
      },
      expression: "product.stock"
    }
  })], 1)], 1), _c('v-card', {
    staticClass: "mx-1 mt-4"
  }, [_c('v-card-title', {
    staticClass: "align-center"
  }, [_c('span', {
    staticClass: "tit tit--xs"
  }, [_c('b', [_vm._v("상품정보")])]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.shoppingEnabled,
      callback: function callback($$v) {
        _vm.shoppingEnabled = $$v;
      },
      expression: "shoppingEnabled"
    }
  })], 1), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.shoppingEnabled,
      expression: "shoppingEnabled"
    }],
    staticClass: "mx-1 mt-3 mt-md-0"
  }, [_vm._l(_vm.product.info, function (item, index) {
    return _c('v-col', {
      key: index,
      staticStyle: {
        "display": "flex"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "상품가격",
        "persistent-placeholder": "",
        "hide-details": ""
      },
      model: {
        value: item.name,
        callback: function callback($$v) {
          _vm.$set(item, "name", $$v);
        },
        expression: "item.name"
      }
    }), _c('v-text-field', {
      attrs: {
        "label": "1,000 (예시)",
        "persistent-placeholder": "",
        "hide-details": ""
      },
      model: {
        value: item.value,
        callback: function callback($$v) {
          _vm.$set(item, "value", $$v);
        },
        expression: "item.value"
      }
    })], 1);
  }), _c('v-layout', {
    staticClass: "mt-2 mx-n1"
  }, [_c('v-flex', {
    staticClass: "px-1",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "px-1",
    staticStyle: {
      "min-width": "auto"
    },
    attrs: {
      "width": "36",
      "color": "primary"
    },
    on: {
      "click": _vm.decrease
    }
  }, [_c('v-icon', [_vm._v("mdi-minus")])], 1)], 1), _c('v-flex', {
    staticClass: "px-1",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "px-1",
    staticStyle: {
      "min-width": "auto"
    },
    attrs: {
      "width": "36",
      "color": "primary"
    },
    on: {
      "click": _vm.increase
    }
  }, [_c('v-icon', [_vm._v("mdi-plus")])], 1)], 1)], 1)], 2)], 1), _c('v-card', {
    staticClass: "mx-1 mt-4"
  }, [_c('v-card-title', {
    staticClass: "align-center"
  }, [_c('span', {
    staticClass: "tit tit--xs"
  }, [_c('b', [_vm._v("품절여부 (판매 / 품절)")])]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.product.soldout,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "soldout", $$v);
      },
      expression: "product.soldout"
    }
  })], 1), _c('v-divider'), _c('v-card-title', {
    staticClass: "align-center"
  }, [_c('span', {
    staticClass: "tit tit--xs"
  }, [_c('b', [_vm._v("진열여부 (진열안함 / 진열)")])]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.product.onDisplay,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "onDisplay", $$v);
      },
      expression: "product.onDisplay"
    }
  })], 1)], 1), _c('v-card', {
    staticClass: "mx-1 mt-4"
  }, [_c('v-card-title', {
    staticClass: "align-center"
  }, [_c('span', {
    staticClass: "tit tit--xs"
  }, [_c('b', [_vm._v("공제분류 (일반상품 / 도서·문화상품)")])]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.product.isDeduction,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "isDeduction", $$v);
      },
      expression: "product.isDeduction"
    }
  })], 1)], 1), _c('v-card', {
    staticClass: "mx-1 mt-4"
  }, [_c('v-card-title', {
    staticClass: "align-center"
  }, [_c('span', {
    staticClass: "tit tit--xs"
  }, [_c('b', [_vm._v("베스트")])]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.product.isBest,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "isBest", $$v);
      },
      expression: "product.isBest"
    }
  })], 1), _c('v-divider'), _c('v-card-title', {
    staticClass: "align-center"
  }, [_c('span', {
    staticClass: "tit tit--xs"
  }, [_c('b', [_vm._v("메인진열")])]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.product.isMain,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "isMain", $$v);
      },
      expression: "product.isMain"
    }
  })], 1), _c('v-divider'), _c('v-card-title', {
    staticClass: "align-center"
  }, [_c('span', {
    staticClass: "tit tit--xs"
  }, [_c('b', [_vm._v("추천")])]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.product.isRecommend,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "isRecommend", $$v);
      },
      expression: "product.isRecommend"
    }
  })], 1), _c('v-divider'), _c('v-card-title', {
    staticClass: "align-center"
  }, [_c('span', {
    staticClass: "tit tit--xs"
  }, [_c('b', [_vm._v("신상품")])]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.product.isNewly,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "isNewly", $$v);
      },
      expression: "product.isNewly"
    }
  })], 1), _c('v-divider'), _c('v-card-title', {
    staticClass: "align-center"
  }, [_c('span', {
    staticClass: "tit tit--xs"
  }, [_c('b', [_vm._v("인기")])]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.product.isPopular,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "isPopular", $$v);
      },
      expression: "product.isPopular"
    }
  })], 1)], 1)], 1)], 1), _c('v-card', {
    staticClass: "mt-4 mx-1"
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs font-weight-bold pb-2"
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('span', [_vm._v("옵션상품")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mb-1 mt-0 pt-0",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.optionalEnabled,
      callback: function callback($$v) {
        _vm.optionalEnabled = $$v;
      },
      expression: "optionalEnabled"
    }
  })], 1)], 1), _c('v-divider'), _c('optional-products', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.optionalEnabled,
      expression: "optionalEnabled"
    }],
    attrs: {
      "salePrice": _vm.product.salePrice
    },
    model: {
      value: _vm.product.optionalProducts,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "optionalProducts", $$v);
      },
      expression: "product.optionalProducts"
    }
  })], 1), _c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    staticClass: "mt-4 mx-1"
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs font-weight-bold pb-2"
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('span', [_vm._v("추가상품")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mb-1 mt-0 pt-0",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.additionalEnabled,
      callback: function callback($$v) {
        _vm.additionalEnabled = $$v;
      },
      expression: "additionalEnabled"
    }
  })], 1)], 1), _c('v-divider'), _c('additional-products', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.additionalEnabled,
      expression: "additionalEnabled"
    }],
    model: {
      value: _vm.product.additionalProducts,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "additionalProducts", $$v);
      },
      expression: "product.additionalProducts"
    }
  })], 1), _c('v-card', {
    staticClass: "mt-4 mx-1"
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs font-weight-bold pb-2"
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('span', [_vm._v("ebook 상품")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mb-1 mt-0 pt-0",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.ebookEnabled,
      callback: function callback($$v) {
        _vm.ebookEnabled = $$v;
      },
      expression: "ebookEnabled"
    }
  })], 1)], 1), _c('v-divider'), _c('ebook-products', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.ebookEnabled,
      expression: "ebookEnabled"
    }],
    attrs: {
      "salePrice": _vm.product.salePrice,
      "enabled": _vm.ebookEnabled,
      "_ebookCompany": _vm.product._ebookCompany
    },
    on: {
      "update:_ebookCompany": function update_ebookCompany($event) {
        return _vm.$set(_vm.product, "_ebookCompany", $event);
      },
      "update:_ebook-company": function update_ebookCompany($event) {
        return _vm.$set(_vm.product, "_ebookCompany", $event);
      }
    },
    model: {
      value: _vm.product.ebookProducts,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "ebookProducts", $$v);
      },
      expression: "product.ebookProducts"
    }
  })], 1), _c('v-card', {
    staticClass: "mt-4 mx-1"
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs font-weight-bold pb-2"
  }, [_vm._v("배송정책")]), _c('v-card-text', [_c('v-radio-group', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "row": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.product.shippingCode,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "shippingCode", $$v);
      },
      expression: "product.shippingCode"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "grow-shrink-0": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "기본 배송정책",
      "value": "order"
    }
  })], 1), _c('v-flex', {
    attrs: {
      "grow-shrink-0": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "무료배송",
      "value": "free"
    }
  })], 1), _c('v-flex', {
    attrs: {
      "grow-shrink-0": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "수신자 부담(착불)",
      "value": "later"
    }
  })], 1), _c('v-flex', {
    attrs: {
      "grow-shrink-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "구매상품별",
      "value": "self"
    }
  }), _c('v-responsive', {
    staticClass: "pa-0 mr-2",
    attrs: {
      "max-width": "200"
    }
  }, [_c('v-text-field', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "full-width": "",
      "suffix": "원",
      "disabled": _vm.product.shippingCode != 'self'
    },
    model: {
      value: _vm.product.shippingPrice,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "shippingPrice", $$v);
      },
      expression: "product.shippingPrice"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('v-card', {
    staticClass: "mt-4 mx-1"
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs font-weight-bold"
  }, [_vm._v("상세정보")]), _c('v-card-text', [_c('naver-smarteditor', {
    model: {
      value: _vm.product.content,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "content", $$v);
      },
      expression: "product.content"
    }
  })], 1)], 1), _c('v-card', {
    staticClass: "mt-4 mx-1"
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs font-weight-bold"
  }, [_vm._v("모바일")]), _c('v-card-text', [_c('naver-smarteditor', {
    model: {
      value: _vm.product.mobileContent,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "mobileContent", $$v);
      },
      expression: "product.mobileContent"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "my-6"
  }, [_c('v-spacer'), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.dialog = true;
      }
    }
  }, [_vm._v("미리보기")])], 1), _c('v-spacer')], 1), _c('v-dialog', {
    attrs: {
      "width": "1200"
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('product-preview', {
    model: {
      value: _vm.product,
      callback: function callback($$v) {
        _vm.product = $$v;
      },
      expression: "product"
    }
  })], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }